// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.info-tag[data-v-208909df] {\r\n  display: flex;\r\n  gap: 8px;\r\n  color: #1F2937;\r\n  font-size: 40px;\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  line-height: 140%;\r\n  \r\n  align-items: center;\n}\n.icon[data-v-208909df] {\r\n  font-size: 36px;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
